// libs
import { styled } from '@nykaa/ui-components';

// component
import HeartIcon from '@nykaa/ui-components/Icons/heart-plus';
import HeartFilledIcon from '@nykaa/ui-components/Icons/heart-filled';
import { BREAKPOINTS } from 'shared/styles/base';

export const WishlistContainer = styled.div`
  text-align: center;
`;

export const AddToWishlistText = styled.span`
  ${({ theme }) => `margin-left: ${theme.spacing.spacing40};`};
  ${({ theme }) => theme.typography.subTitleSmall};
  ${({ theme }) => `color: ${theme.colors.primary};`};
  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme }) => theme.typography.buttonMedium}
  }
`;

export const HeartFilled = styled(HeartFilledIcon)`
  vertical-align: middle;
  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    height: 20px;
    width: 20px;
  }
`;

export const HeartEmpty = HeartFilled.withComponent(HeartIcon);
